import {IController, IModule} from "angular";

const css = require('./flagg.scss');

export class FlaggKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular.component('flagg', {
            bindings: {land: '<', hoyde: '@?'},
            controller: FlaggKontroller.forInjisering(),
            template: require('./flagg.html')
        });
    }

    static forInjisering() {
        return [FlaggKontroller]
    }

    constructor() {
    }

    land: string; //settes via bindings/$onChanges
    hoyde: number = 24; //settes via bindings/$onChanges

    bredde: number = 32;

    $onInit(): void {
        this.bredde = this.hoyde * (4/3);
    }

}

